let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9U6X2")).then(() => parcelRequire('9fdve'));